import React from 'react';
import InputField from '../../component/form/FormInput';
import { useSelector } from 'react-redux';
import { newObjectCreater } from '../../utils/controller';
import InputSelect from '../../component/inputSelect/InputSelect';

const VendorsAddress = ({ data, error, disabled, handleInputChange, cityList, getCity }) => {
	let masterData = useSelector((state) => state?.master?.masterData?.data);

	const countryList = newObjectCreater(masterData?.countries);
	const StateList = newObjectCreater(masterData?.states);

	const handleZipChange = (value) => {
		handleInputChange('zip_code', value);
	};

	return (
		<div>
			<div className="row">
				<div className="col">
					<InputField
						label="Attention "
						placeholder="Attention"
						type="text"
						value={data.attention}
						onChange={(value) => handleInputChange('attention', value)}
						disabled={disabled}
						error={error?.attention}
					/>
				</div>
				<div className="col">
					<InputSelect
						label="Country "
						placeholder="Select Country"
						onSelect={(value) => handleInputChange('country_id', Number(value.key))}
						value={data.country_id}
						onChange={(value) => {}}
						options={countryList}
						disabled={disabled}
						name={'country_id'}
						error={error?.country_id}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<InputField
						label="Address Street 1"
						placeholder="Address Street 1"
						type="text"
						value={data.street_1}
						onChange={(value) => handleInputChange('street_1', value)}
						disabled={disabled}
						error={error?.street_1}
					/>
				</div>
				<div className="col">
					<InputField
						label="Address Street 2 "
						placeholder="Address Street 2"
						type="text"
						value={data.street_2}
						onChange={(value) => handleInputChange('street_2', value)}
						disabled={disabled}
						error={error?.street_2}
					/>
				</div>
			</div>
			<div className="row">
				<div className="col">
					<InputSelect
						label="State"
						placeholder="Select State"
						onSelect={(value) => {
							handleInputChange('state_id', value.key);
							getCity(value.key);
						}}
						value={data.state_id}
						onChange={(value) => {}}
						options={StateList}
						disabled={disabled}
						name={'state_id'}
						error={error?.state_id ? 'is not allowed to be empty.' : ''}
					/>
				</div>
				<div className="col">
					<InputSelect
						label="City"
						placeholder="Select City"
						onSelect={(value) => handleInputChange('city_id', value.key)}
						value={data.city_id}
						options={cityList}
						disabled={disabled}
						onChange={(value) => {}}
						name={'city_id'}
						error={error?.city_id ? 'is not allowed to be empty.' : ''}
					/>
				</div>
				<div className="col">
					<InputField
						label="Zip Code"
						placeholder="Zip code"
						type="text"
						value={data.zip_code}
						onChange={handleZipChange}
						disabled={disabled}
						error={error?.zip_code}
					/>
				</div>
			</div>
		</div>
	);
};

export default VendorsAddress;
